/* eslint-disable react/jsx-props-no-spreading,
 * jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import IconStarFilled from 'components/shared/SVG/IconStarFilled';
import IconStarUnfilled from 'components/shared/SVG/IconStarUnfilled';
import { FormContext, Rating } from './ratingsSurveyModalTypes';

import { mParticleCustomEvents, mParticleEventTypes } from 'helpers/mParticle';
import { sendEvent } from './eventUtils';

import styles from './RatingsSurveyModal.module.scss';

interface RatingQuestionProps {
  formContext: FormContext;
  rating: Rating;
  restaurantName: string;
}

export default function RatingQuestion({
  formContext,
  rating,
  restaurantName,
}: RatingQuestionProps) {
  const router = useRouter();

  const { register, setValue, trigger, watch } = formContext;
  const questionText = `How was ${restaurantName}?`;
  const choices: Array<Rating> = [1, 2, 3, 4, 5];

  const selectedRating = watch('rating') || rating;

  function updateRatingInForm(rating: Rating): void {
    // Since the radio input is hidden, we need to set the value manually
    // when the containing label + image is clicked
    setValue('rating', rating, { shouldDirty: true });

    // We also need to trigger validation to see if we should
    // activate the submit button
    trigger('rating');
  }

  function handleRatingClicked(rating: Rating): void {
    updateRatingInForm(rating);

    // Send mParticle event whenever the customer chooses a rating
    sendEvent(router.query, formContext, mParticleCustomEvents.selectRestaurantRating, mParticleEventTypes.UserPreference);
  }

  useEffect(() => {
    updateRatingInForm(rating);
  }, [rating]);

  return (
    <div className={classNames(styles.question, styles.starScale)} data-testid="RatingQuestion">
      <h3 className={styles.questionText}>{questionText}</h3>
      <div className={styles.scale}>
        {choices.map((choice) => (
          <label
            key={choice}
            htmlFor={`rating=${choice}`}
            className={styles.star}
            onClick={() => handleRatingClicked(choice)}
          >
            <input
              {...register('rating')}
              id={`rating-${choice}`}
              data-testid={`rating-${choice}`}
              value={choice}
              type="radio"
              checked={selectedRating === choice}
            />

            {choice <= selectedRating ? <IconStarFilled /> : <IconStarUnfilled />}
          </label>
        ))}
      </div>
      <div className={styles.labels}>
        <span>Poor</span>
        <span>Excellent</span>
      </div>
    </div>
  );
}
